"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRestrictedEventIds = exports.restrictedByAdmin = exports.restrictedByEvents = void 0;
var GroupAccessRestriction_1 = require("../../GroupAccessRestriction");
function restrictedByEvents(accessRestriction) {
    return (accessRestriction === null || accessRestriction === void 0 ? void 0 : accessRestriction.type) === GroupAccessRestriction_1.RestrictionType.EVENTS;
}
exports.restrictedByEvents = restrictedByEvents;
function restrictedByAdmin(accessRestriction) {
    return (accessRestriction === null || accessRestriction === void 0 ? void 0 : accessRestriction.type) === GroupAccessRestriction_1.RestrictionType.ADMIN_APPROVAL;
}
exports.restrictedByAdmin = restrictedByAdmin;
function getRestrictedEventIds(group) {
    var _a, _b;
    return (_b = (_a = group.accessRestriction) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.eventIds;
}
exports.getRestrictedEventIds = getRestrictedEventIds;
//# sourceMappingURL=index.js.map